import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col } from 'react-bootstrap'

//components
import withLocalization from '~/hoc/withLocalization';
import SwitchWidget from '../../SwitchWidget';

//elements
import Select from '~/elements/Select.js';
import { Input } from '~/elements/Input.js';

//utils
import { payrollIntegrationOptions } from '~/utils/constants';

class VacationOthersSettings extends Component {
    constructor(props) {
        super(props);
        const { currentEntity } = props.clientStore;
        const Vacation_setup = Object.assign({}, currentEntity.client.data.Vacation_setup);
        const vacationOtherSettings = Vacation_setup.vacationOtherSettings || {};
        this.integration_details = props.commonStore?.config?.integration_details;
        this.isXledgerOrTripletex = this.integration_details?.product === payrollIntegrationOptions.XLEDGER || this.integration_details?.product === payrollIntegrationOptions.TRIPLETEX;
        const wageType = props.commonStore.getWageTypesAccordingToIntegrations(this.integration_details, 'ab') || [];
        this.wageTypeOptions = wageType.map(item => ({ value: item.value, label: item.label, projectDbId: item.projectDbId }));
        this.state = {
            allow_bulk_vacation: vacationOtherSettings.allow_bulk_vacation || false,
            allow_staggered_vacation: vacationOtherSettings.allow_staggered_vacation || false,
            wage_type: vacationOtherSettings.wage_type || null,
            replace_label: vacationOtherSettings.replace_label || '',
        }
        this.handleUserDataChange = this.handleUserDataChange.bind(this);
    }

    handleUserDataChange = (name, value) => {
        const { currentEntity } = this.props.clientStore;
        const Vacation_setup = Object.assign({}, currentEntity.client.data.Vacation_setup);
        const vacationOtherSettings = { ...Vacation_setup.vacationOtherSettings, [name]: value };
        currentEntity.client.data.Vacation_setup = { ...Vacation_setup, vacationOtherSettings };
    }

    handleFieldChange = (name, value) => {
        this.setState({ [name]: value }, () => this.handleUserDataChange(name, value));
    }

    render() {
        const { t } = this.props;
        const { allow_bulk_vacation, allow_staggered_vacation, wage_type, replace_label } = this.state;
        return (
            <>
                <Row className='mt-2'>
                    <Col md={3}>
                        <label className="control-label font-size-15 mt-2 font-color-primary">{t('Bulk vacation settings')}</label>
                    </Col>
                </Row>
                <Row className='align-items-center mt-3 mb-2'>
                    <Col xs={1} className='mt-1'>
                        <SwitchWidget
                            value={allow_bulk_vacation}
                            onChange={checked => this.handleFieldChange('allow_bulk_vacation', checked)}
                        />
                    </Col>
                    <Col xs={11}>
                        <label className="control-label">{t('Allow bulk vacation registration')}</label>
                    </Col>
                </Row>
                <Row className='align-items-center mb-2'>
                    <Col xs={1} className='mt-1'>
                        <SwitchWidget
                            value={allow_staggered_vacation}
                            onChange={checked => this.handleFieldChange('allow_staggered_vacation', checked)}
                        />
                    </Col>
                    <Col xs={11}>
                        <label className="control-label">{t('Allow staggered vacation requests')}</label>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col xs={6}>
                        <label className="control-label">
                            {this.isXledgerOrTripletex ? t('Activity') : t('Wage Type')}
                        </label>
                        <Select
                            options={this.wageTypeOptions}
                            value={wage_type}
                            onChange={value => this.handleFieldChange('wage_type', value)}
                            placeholder={this.isXledgerOrTripletex ? t('Select Activity') : t('Select Wage Type')}
                        />
                    </Col>
                    <Col xs={6}>
                        <label className="control-label">{t('Replace label')}</label>
                        <Input
                            name="replace_label"
                            value={replace_label}
                            placeholder={t('Enter label')}
                            onChange={evt => this.handleFieldChange('replace_label', evt.target.value)}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}
export default inject('clientStore', 'commonStore')(withLocalization(observer(VacationOthersSettings)));
